import klaxMascotVideoLight from 'assets/images/magnific_mascott-t-light.mp4';
import klaxMascotVideoDark from 'assets/images/magnific_mascott-t.mp4';
import { useTheme } from 'components/core/theme-provider';
import { cn } from 'lib/utils';
import { useEffect, useRef } from 'react';
import { SeliseAssistantLogo } from 'features/chat/components/MessageLoading';

const DEFAULT_TITLE = 'Welcome to SELISE AI!';

export interface KlaxWelcomeProps {
  className?: string;
  title?: string;
}

export function KlaxWelcome({ className, title = DEFAULT_TITLE }: KlaxWelcomeProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const klaxMascotVideo = isDark ? klaxMascotVideoDark : klaxMascotVideoLight;
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;

    void video.play().catch(() => {
      // Autoplay may be blocked; keep the first frame visible.
    });
  }, [klaxMascotVideo]);

  const handleVideoEnded = () => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.pause();
  };

  return (
    <div className={cn('flex h-auto min-h-16 items-center gap-2 sm:h-20 sm:gap-2.5 justify-center', className)}>
      <SeliseAssistantLogo className="size-[50px] shrink-0 object-contain" />

      <p
        className={cn(
          'font-sans min-w-0 text-2xl font-normal leading-[1.1] xs:text-[32px] md:text-[36px] xl:text-[36px]',
          isDark ? 'text-[#999781]' : 'text-grey-950'
        )}
      >
        {title}
      </p>
    </div>
  );
}
